import { ListRepository } from '../abstraction';
import { ReadonlyHttpApiListRepository } from './readonly-http-api-list.repository';
import { ApiDataAccess } from '../../data-access/api.data-access';
import { Dictionary } from '../../types/dictionary';

export abstract class HttpApiListRepository<TItem, TResult, TLoadParams = undefined, TCrudParams = undefined>
  extends ReadonlyHttpApiListRepository<TResult, TLoadParams>
  implements ListRepository<TItem, TResult, TLoadParams, TCrudParams>
{
  protected constructor(
    protected override dataAccess: ApiDataAccess,
    protected override path: string | string[]
  ) {
    super(dataAccess, path);
  }

  create(items: TItem[], params: TCrudParams): Promise<TResult> {
    return this.dataAccess.create<any, TResult>({
        path: this.path,
        pathParams: this.getCRUDPathParams(params),
        queryParams: undefined,
      }, items
    );
  }

  update(items: TItem[], params: TCrudParams): Promise<TResult> {
    return this.dataAccess.patch<any, TResult>({
      path: this.path,
      pathParams: this.getCRUDPathParams(params),
      queryParams: undefined,
    }, items);
  }

  delete(params: TCrudParams): Promise<TResult> {
    return this.dataAccess.delete<TResult>({
      path: this.path,
      pathParams: this.getCRUDPathParams(params),
    });
  }

  protected abstract getCRUDPathParams(params: TCrudParams): Dictionary<unknown> | undefined;
}
